import React from 'react';
import {Stack} from '@mui/material';
import {Body, Icon, designSystemToken} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

interface CampaignHistoryCellProps {
  count: number;
  rating: number | null;
}

function CampaignHistoryCell({count, rating}: CampaignHistoryCellProps) {
  return (
    <Stack direction="row" alignItems="center" gap="4px">
      {rating !== null && count > 0 && (
        <>
          <Icon size="small" appearance="neutral" name="Navigation-Star-Fill" />
          <Body size="sm">{rating}</Body>
        </>
      )}
      <Body size="sm" color={designSystemToken('semantic.fg.secondary')}>
        {translate('creator-campaign-count', {count})}
      </Body>
    </Stack>
  );
}

export default CampaignHistoryCell;
